import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class MapIconService {
  /**
   * Renders an icon with a specified background color and SVG code.
   *
   * @param {string} backgroundColor - The background color to be applied to the icon's circle.
   * @param {string} iconCode - The SVG code representing the icon to be displayed.
   * @param {number} size - The rendered icon size in pixels.
   * @return {HTMLElement | string} The rendered SVG element as a string or an HTMLElement.
   */
  public renderIcon(backgroundColor: string, iconCode: string, size: number = 12): HTMLElement | string {
    return `
<svg xmlns="http://www.w3.org/2000/svg" width="${ size }" height="${ size }" viewBox="0 0 24 24">
  <circle cx="12" cy="12" r="12" fill="${ backgroundColor }" />
  <g transform="translate(2 2)">
    <svg xmlns="http://www.w3.org/2000/svg"
        height="20px"
        width="20px"
        viewBox="0 -960 960 960">
      ${ iconCode }
    </svg>
  </g>
</svg>
    `;
  }
}
